import React from 'react';
import { graphql } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Layout } from '~/components/molecules/Layout';
import { SEO } from '~/components/atoms/SEO';
// eslint-disable-next-line import/no-cycle
import DemenzPage from './Illnesses/DemenzPage/DemenzPage';
import { TranslationContext } from '~/utils/styles/utils';

const Demenz: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <SEO title={t('SeoTitle')} metaDescription={t('SeoMetaDescription')} />
      <TranslationContext.Provider value={t}>
        <DemenzPage />
      </TranslationContext.Provider>
    </Layout>
  );
};

export const useTranslationContext = () => React.useContext(TranslationContext);

export default Demenz;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(
      filter: { ns: { in: ["dementiapage"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
